module.exports = __webpack_public_path__ + "img/souji_n1vt.bb26aa46.png";